module.exports = __webpack_public_path__ + "static/media/discover_5.f8476cf0.svg";